import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { dashboardLayoutComponent } from '@/routes/layouts/dashboard-layout-route';
import type { FilterDrawerFormValue } from '@/components/shared/filter-drawer/types';

// DEPOSIT-VA
export const depositVa = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/deposit-va',
  component: lazyRouteComponent(() => import('@/pages/invoices/deposit-va')),
  validateSearch: (search: Record<string, unknown>): FilterDrawerFormValue => {
    return {
      ...search,
    };
  },
});

export const depositVaDetail = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/deposit-va/$id',
  component: lazyRouteComponent(() => import('@/pages/invoices/deposit-va/[id]')),
});
